export default __webpack_public_path__ + "static/cloud_2-26197ead215902eea2e285b315c81e1f.png";